import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconClose = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M3.32 1.945c-.703.203-1.28.841-1.406 1.553-.082.465 0 1.01.206 1.357.076.128 6.189 6.288 13.585 13.689L29.15 32 15.672 45.488C5.204 55.963 2.163 59.04 2.061 59.264c-.678 1.477.594 3.117 2.189 2.823.204-.038.477-.131.605-.207s6.288-6.19 13.689-13.585L32 34.848l13.456 13.447c7.4 7.396 13.56 13.509 13.689 13.585.852.504 2.073.196 2.646-.667.402-.605.44-1.476.089-2.068-.076-.128-6.19-6.288-13.585-13.689L34.848 32l13.447-13.456c7.396-7.4 13.509-13.56 13.585-13.689.075-.128.168-.399.206-.602.297-1.607-1.311-2.86-2.822-2.198-.23.1-3.017 2.854-13.776 13.611L32 29.151 18.512 15.666C7.424 4.58 4.97 2.157 4.722 2.048c-.384-.168-1.015-.215-1.402-.103" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconClose.displayName = 'IconClose';